<mat-card class="content-card">
  <mat-card-header fxLayoutAlign="space-between center">
    <mat-card-title>
      <h5>Order email templates</h5>
    </mat-card-title>
    <div fxFlex></div>
    <a mat-raised-button color="primary" routerLink="order-email/add">Add</a>
  </mat-card-header>
  <mat-card-content>
    <mat-nav-list role="list">
        <div *ngFor="let item of dataSource" fxLayout="row">
          <a mat-list-item fxFlex [routerLink]="'order-email/' + item.id">{{item.name}}</a>
          <button mat-icon-button (click)="copyTemplate(item.id)">
            <mat-icon>content_copy</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteTemplate(item.id)">
            <mat-icon style="color: orangered;">delete</mat-icon>
          </button>
        </div>
    </mat-nav-list>
  </mat-card-content>
</mat-card>
